import { render, staticRenderFns } from "./ConfiguratorStep.vue?vue&type=template&id=ba9ca78e&scoped=true&"
import script from "./ConfiguratorStep.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ca78e",
  null
  
)

export default component.exports